import type { UseQueryOptions } from "@pinia/colada";

import type { LocaleMorpheus } from "@solvari/translations";

import { kyCacheTags } from "~/shared/composables/useCacheTags.ts";
import { handleNuxtQuery } from "~/shared/libs/networkErrorHandling.ts";
import { ziggy } from "~/shared/libs/ziggy.ts";

function useHomepageReviews(params: { locale: LocaleMorpheus }) {
  const url = ziggy("api.v3.main-site.homepageReviews");
  return {
    key: () => ["api", "homepage", "reviews", params.locale],
    query: handleNuxtQuery(() =>
      kyCacheTags
        .get(url, {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          headers: { "solvari-locale": params.locale },
        })
        .json<App.DTO.Customer.Review.CustomerReviewDTO[]>(),
    ),
    staleTime: 30 * 60_000,
  } satisfies UseQueryOptions;
}

export { useHomepageReviews };
